import { render, staticRenderFns } from "./TenantPicker.vue?vue&type=template&id=81ae8820&"
import script from "./TenantPicker.vue?vue&type=script&lang=js&"
export * from "./TenantPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports